import PropTypes from "prop-types";

const DialogPropTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  confirmBtnTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  confirmBtnColor: PropTypes.string,
  isConfirming: PropTypes.bool,
  disableConfirmBtn: PropTypes.bool,
  closeBtnTitle: PropTypes.string,
  onConfirm: PropTypes.func,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  disableFooter: PropTypes.bool,
  isDeleteDiaglog: PropTypes.bool,
  footerContent: PropTypes.element,
  noScroll: PropTypes.bool,
  titleSecondary: PropTypes.string,
};

export default DialogPropTypes;
